import { createWaveClipPath } from "../utils/utils";
const classRoom = () => {
  const pageMarker = $("._classRoom_");
  if (!pageMarker.length) return;
  // createWaveClipPath<string>(
  //   "M0.000,0.000 C1.000,0.000 130.802,50.809 270.000,78.000 C409.198,105.191 492.652,115.000 573.000,119.1000 C653.348,124.1000 810.285,127.449 942.000,112.1000 C1077.291,97.530 1159.341,72.992 1369.1000,61.000 C1580.659,49.008 1620.170,56.562 1722.1000,62.1000 C1825.830,69.438 1910.950,90.046 {$w},92.000 C{$w},104.680 {$w},124.1000 {$w},124.1000 L{$w},{$h} L0.000,{$h} L0.000,0.000 Z",
  //   { target: pageMarker.find(".main-content") }
  // );
};

export default classRoom;
